'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

var _utils2 = require('../../../core/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// This component is used to view specific departures
// Select departures with departures param
var WinresDeparturesView = function () {
    function WinresDeparturesView($scope, departureService, localizationService) {
        _classCallCheck(this, WinresDeparturesView);

        this.$scope = $scope;
        this.departureService = departureService;
        this.localizationService = localizationService;
        this.status = 'waiting';
        this.results = [];
    }

    _createClass(WinresDeparturesView, [{
        key: '$onInit',
        value: function $onInit() {
            this.reservationLinkTemplate = this.reservationLinkTemplate || 'kohde';
            this.useSeoLinks = this.winresReservationContext.getSeoState();
            this.getResults();
        }
    }, {
        key: 'getDestCodes',
        value: function getDestCodes() {
            if (!this.departures) {
                return [];
            }

            var codes = [];

            var departures = this.departures.split(',');
            _.each(departures, function (departure) {
                codes.push(departure.split(';')[0]);
            });

            return codes;
        }
    }, {
        key: 'getSearchCriteria',
        value: function getSearchCriteria() {
            return {
                'Language': this.localizationService.getLanguage(),
                'Offset': 0,
                'BeginDate': moment().format('YYYY-MM-DD'),
                'EndDate': null,
                'DestCodes': this.getDestCodes(),
                'IgnoreCapacity': true,
                'IgnoreEverything': false,
                'NumAdults': 2
            };
        }
    }, {
        key: 'getResults',
        value: function getResults() {
            var _this = this;

            this.status = 'loading';

            var searchCriteria = this.getSearchCriteria();
            this.searchCriteria = searchCriteria;
            this.departureService.searchDepartures(searchCriteria).then(function (result) {
                var results = result.Results;
                var departures = _this.departures.split(',');
                _.each(departures, function (departure) {
                    var _departure$split = departure.split(';'),
                        _departure$split2 = _slicedToArray(_departure$split, 2),
                        destCode = _departure$split2[0],
                        beginDate = _departure$split2[1];

                    // Select departure that StartDate equals beginDate


                    if (beginDate) {
                        var found = _.find(results, function (result) {
                            return result.DestinationCode === destCode && result.StartDate === beginDate;
                        });
                        if (found) {
                            _this.results.push(found);
                        } else {
                            console.warn('[WDV] Departure not found. DestCode=' + destCode + 'BeginDate=' + beginDate);
                        }
                    } else {
                        // Select first departure
                        var _found = _.filter(results, function (result) {
                            return result.DestinationCode === destCode;
                        });
                        if (_found && _found.length > 0) {
                            _this.results.push(_found[0]);
                        } else {
                            console.warn('[WDV] First departure not found. DestCode=' + destCode);
                        }
                    }

                    _this.status = _this.results.length > 0 ? 'ready' : 'error';
                });

                // Modify results
                _.each(_this.results, function (result) {
                    result.DateRange = (0, _utils2.formatDateRange)(result.StartDate, result.EndDate);
                    _this.updateLink(result);
                });
            });
        }
    }, {
        key: 'updateLink',
        value: function updateLink(result) {
            result.ReserveLink = (0, _utils.getReservationLinkWithWPMLAndSeo)(this.reservationLinkTemplate, result.DestinationName, result.DestinationCode, result.StartDate, result.EndDate, this.localizationService.getLanguage(), this.searchCriteria.NumAdults, this.searchCriteria.NumChildren, this.searchCriteria.NumInfants, false, // noDates
            this.useSeoLinks, // seo 
            document.querySelector("meta[name=generator][content^='WPML']"), // wpml
            true); // departure
        }
    }]);

    return WinresDeparturesView;
}();

WinresDeparturesView.$inject = ['$scope', 'departureService', 'localizationService'];

function getTemplate($attrs, $sce) {
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'departures-view-default';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('departures-view-default', require('./winresDeparturesView.html'));
}]);

_module3.default.component('winresDeparturesView', {
    templateUrl: getTemplate,
    controller: WinresDeparturesView,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        // Departures to search
        // <DestCode>;<BeginDate(YYYY-MM-DD, optional)>,<DestCode>;<BeginDate(YYYY-MM-DD, optional)>,...
        // <DestCode>,<DestCode>,...
        // PMALB;2020-01-01,PMGROUP;2020-01-02,TLOVYO
        // Select first departure if BeginDate is not set
        departures: '@',

        // Reserve links have target="_blank". Used in cases where the
        // departure list is shown on the customer's web page or somewhere other
        // than the reservation site. (e.g. links to Intres or something.)
        // Default: false
        reserveInNewWindow: '@',

        reservationLinkTemplate: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresDeparturesView/winresDeparturesView.js
// module id = 296
// module chunks = 2